/* defines the reasons why the threshold simulator may be disabled */
export const thresholdSimDisableReason = {
  invalidDataType: 'invalidDataType',
  invalidOperator: 'invalidOperator',
  invalidSave: 'invalidSave',
  invalidThreshold: 'invalidThreshold',
  insufficientEvaluations: 'insufficientEvaluations',
  lhsChanged: 'lhsChanged',
  pendingData: 'pendingData',
} as const;

export type ThresholdSimDisableReason = keyof typeof thresholdSimDisableReason;
